import React, { Component } from "react";
import { LocaleConsumer } from "contexts/locale-context";
import { fromRenderProps } from "recompose";
import { IntlProvider } from "react-intl";
import { flattenMessages } from "locale/flat";

import kr from "./kr";
import en from "./en";
import cn from "./cn";
import jp from "./jp";

class Translate extends Component {
  state = {
    langs: {
      kr,
      en,
      cn,
      jp
    }
  };

  render() {
    const { langs } = this.state;
    const locale = localStorage.getItem("ctcrLocale");

    let language;
    let localeTxt;

    switch (locale) {
      case "kr":
        language = langs.kr;
        localeTxt = "ko";
        break;
      case "en":
        language = langs.en;
        localeTxt = "en";
        break;
      case "cn":
        language = langs.cn;
        localeTxt = "zh";
        break;
      case "jp":
        language = langs.jp;
        localeTxt = "ja";
        break;
      default:
        language = langs.kr;
        localeTxt = "ko";
    }

    return (
      <IntlProvider locale={localeTxt} messages={flattenMessages(language)}>
        {this.props.children}
      </IntlProvider>
    );
  }
}

export default fromRenderProps(LocaleConsumer, ({ state }) => ({
  locale: state.locale
}))(Translate);
